import {
  useState,
} from 'react'
import {
  Button,
  Form,
  Spinner,
} from 'react-bootstrap'
import useApiRequest from './hooks/useApiRequest'
import useCognitoUser from './hooks/useCognitoUser'
import useResident from './hooks/useResident'

const ResidentForm = () => {
  const { user, userId } = useCognitoUser()
  const { apiPost } = useApiRequest()
  const { fetchResident } = useResident()

  const { email, given_name, family_name, phone_number } = user.attributes

  const [contactFirstName, setContactFirstName] = useState(given_name)
  const [contactLastName, setContactLastName] = useState(family_name)
  const [contactEmail, setContactEmail] = useState(email)
  const [contactPhone, setContactPhone] = useState(phone_number)
  const [unit, setUnitNumber] = useState("")
  const [hasPadSetUp, setHasPadSetUp] = useState(false)
  const [saving, setSaving] = useState(false)

  const canSignUp = (!!contactFirstName && !! contactLastName && !!contactEmail && !!contactPhone && !!unit)

  const onSignUp = () => {
    const payload = {
      user_id: userId,
      first_name: contactFirstName,
      last_name: contactLastName,
      email: contactEmail,
      phone: contactPhone,
      unit,
      pad_set_up: hasPadSetUp,
    }

    setSaving(true)

    apiPost(`residents`, payload)
      .then(() => {
        fetchResident()
        setSaving(false)
      })
  }

  return (
    <Form>
      <Form.Group className="mb-3">
        <Form.Label>First Name</Form.Label>
        <Form.Control type="text" value={contactFirstName} onChange={(e) => setContactFirstName(e.target.value)} />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Last Name</Form.Label>
        <Form.Control type="text" value={contactLastName} onChange={(e) => setContactLastName(e.target.value)} />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Email</Form.Label>
        <Form.Control type="email" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Phone</Form.Label>
        <Form.Control type="phone" value={contactPhone} onChange={(e) => setContactPhone(e.target.value)} />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Unit Number</Form.Label>
        <Form.Control type="number" value={unit} onChange={(e) => setUnitNumber(e.target.value)} />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Check
          type="checkbox"
          id="agree-to-terms"
          label="I have already set up pre-authorized debit (PAD) with Davin Management"
          checked={hasPadSetUp}
          onChange={({ target }) => setHasPadSetUp(target.checked)}
        />
      </Form.Group>

      {!saving && <Button key="submit" variant="primary" disabled={!canSignUp} onClick={onSignUp}>Finish Sign Up</Button>}
      {saving && <Spinner animation="border" role="status" variant="info" />}
    </Form>
  )
}

export default ResidentForm
